import { Component } from '@angular/core';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { ResetPasswordComponent } from '@shared/components/reset-password/reset-password.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  imports: [FooterComponent, ResetPasswordComponent, HeaderComponent]
})
export class ForgotPasswordComponent {

  constructor(
  ) {

  }


}
